import script from "./WelcomeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeDialog.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeDialog.vue?vue&type=style&index=0&id=32ece673&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/jenkins_home/workspace/QuickApp_NapH5_YQZK_YiZhiAiChong/yzac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32ece673"]])

export default __exports__